export default __webpack_public_path__ + "static/nestery-771188d4dfb385f4791c2d3924e4f9bf.png";